// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p7-1";
export var messageSideRight = "_p7-2";
export var orderLookupBubbleContainer = "_p7-0";
export var submitButton = "_p7-3";